import React, {
  FC, useState
} from 'react';

import {
  Logo
} from 'src/shared/components';
import {
  HelpCenter,
  Navigation,
  Notifications,
  SuggestQuestionModal,
} from 'src/features';
import {
  HeaderSearch, MyProfileMenu
} from 'src/widgets';
import {
  useTypedSelector
} from 'src/redux';
import {
  organizationSelectors
} from 'src/redux/organizations';
import {
  useGetApiOrganizationsSuggestionsAvailableQuery
} from 'src/redux/openapi';
import {
  PlusIcon
} from 'src/shared/icons';

import * as Style from './Header.styles';

interface HeaderProps {
  isGeneral?: boolean;
}

export const Header: FC<HeaderProps> = ({
  isGeneral
}) => {
  const theme = useTypedSelector(organizationSelectors.orgUsersTheme);

  const [isSuggestModalOpen, setIsSuggestModalOpen] = useState(false);

  const {
    data: availabilityData
  } = useGetApiOrganizationsSuggestionsAvailableQuery();

  const isImageSrc = !!theme?.logoUrl;

  const suggestionOrgId = availabilityData?.data.organizationId ?? null;
  const suggestionTitle = availabilityData?.data.suggestionTitle ?? null;

  return (
    <Style.Header $isCustom={isImageSrc}>
      <Style.LeftContainer>
        <Style.LogoContainer $isCustom={isImageSrc}>
          <Logo />
        </Style.LogoContainer>

        <Navigation isGeneral={isGeneral} />
      </Style.LeftContainer>

      {!isGeneral && (
        <Style.RightContainer>
          <HeaderSearch />

          {!!suggestionOrgId && (
            <button
              type="button"
              onClick={() => setIsSuggestModalOpen(true)}
              className="flex items-center justify-center w-5 h-9 text-dark-gray"
            >
              <PlusIcon className="w-5 h-5" />
            </button>
          )}

          <Notifications />

          <HelpCenter />

          <MyProfileMenu />
        </Style.RightContainer>
      )}

      {!!suggestionOrgId && (
        <SuggestQuestionModal
          isOpen={isSuggestModalOpen}
          onClose={() => setIsSuggestModalOpen(false)}
          organizationId={suggestionOrgId}
          suggestionTitle={suggestionTitle}
        />
      )}
    </Style.Header>
  );
};
